import type { BrandJson } from "@coras-io/brand-tokens";
import { DEFAULT_CURRENCIES, type SiteConfig } from "../../src/types";
import brandConfig from "./brand.json";

// Brand note: the solid navbar and footer backgrounds are the gradient's leading
// and mid stops, for the surfaces that cannot paint a gradient (menu, borders, email).
export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "06e0176fe61c4f63abdddb7a841ad458",
  title: "Experiences | Riyadh Air",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "en-US",
  currency: "USD",
  // Arabic and the riyal lead the pickers: this is a Saudi carrier, and the
  // shared sets carry neither (see SITE_LOCALES, SITE_CURRENCIES). The language
  // menu is Arabic and English alone; every English in the shared set renders as
  // "English", so only the site's default one is listed.
  locales: ["ar-SA", "en-US"],
  currencies: ["SAR", ...DEFAULT_CURRENCIES],
  favicons: ["apple-touch-icon.png", "favicon.ico"],
  logo: "/assets/images/logo.svg",
  domain: "experiences.riyadhair.com",
  website: "https://riyadhair.com",
  detectLocale: true,
  detectCurrency: true,
};
